var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorialSpinStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 303,
    height: 303,
    viewBox: "0 0 303 303",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_7396_369314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.5 16L156.919 124.256L203.354 26.3143L166.932 128.404L247.313 55.687L174.596 136.068L276.686 99.6464L178.744 146.081L287 151.5L178.744 156.919L276.686 203.354L174.596 166.932L247.313 247.313L166.932 174.596L203.354 276.686L156.919 178.744L151.5 287L146.081 178.744L99.6464 276.686L136.068 174.596L55.687 247.313L128.404 166.932L26.3143 203.354L124.256 156.919L16 151.5L124.256 146.081L26.3143 99.6464L128.404 136.068L55.687 55.687L136.068 128.404L99.6464 26.3143L146.081 124.256L151.5 16Z",
    fill: "#0BC4F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_7396_369314",
    x: 0,
    y: 0,
    width: 303,
    height: 303,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "effect1_foregroundBlur_7396_369314"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorialSpinStar);
export default __webpack_public_path__ + "static/media/tutorial-spin-star.775d1d421d494e4f4ca46609c0d0435e.svg";
export { ForwardRef as ReactComponent };